"use client";
// css
import styles from "./index.module.scss";
// view
import { Carousel } from "antd";
import Image from "next/image";
//request
import { queryBannerList } from "@/app/api/chatContent";
// ts
// import { useTranslation } from "@/app/i18n/client";
import { useEffect, useState, useRef } from "react";
// import { TFunction } from "i18next";
import { openUrl } from "@/app/utils";
import Locale, { getLang } from "@/app/locales";
// type
import { ImageItemType } from "@/app/types/typeConfig/chatQuestion";
import { useTranslations, useCurrentLocale } from "@/app/lib/LocaleProvider";

const defaultImagesOptions = (): ImageItemType[] => [
  {
    src: "/images/banner1.png",
    path: "https://us.store.bambulab.com/",
    text: Locale.carouselImageList.title1,
  },
];

export default function CarouselImageList() {
  const [imagesList, setImageList] = useState<ImageItemType[]>([]);
  const [clientReady, setClientReady] = useState(false);
  // const { addToReportQueue } = useReportRequestQueue();
  console.log("lng==", Locale.carouselImageList.title1);
  const locale = useCurrentLocale();

  // 添加 ref 追踪最后一次请求的 locale，避免重复请求
  const lastRequestedLocaleRef = useRef<string | null>(null);

  const onImageClick = (item: ImageItemType) => {
    // TODO: 埋点
    // addToReportQueue({
    //   bizType: ReportBizTypeEnum.BANNER,
    //   content: item.text,
    //   extendField2: item.path,
    //   createTime: new Date().getTime(),
    //   eventType: ReportEventEnum.CLICK,
    //   scene: ReportSceneTypeEnum.NORMAL_CONSULT,
    // });
    openUrl(item.path);
  };

  useEffect(() => {
    setClientReady(true);
    async function requireData() {
      // 如果已经请求过相同的 locale，跳过
      if (lastRequestedLocaleRef.current === locale) {
        console.log(
          `[CarouselImageList] Skipping duplicate request for locale: ${locale}`,
        );
        return;
      }

      console.log(`[CarouselImageList] Fetching data for locale: ${locale}`);
      lastRequestedLocaleRef.current = locale;

      const params = {
        languageCode: locale,
      };
      const res = await queryBannerList(params);
      if (res?.length) {
        const result = res
          .sort((a, b) => a.sortCode - b.sortCode)
          .map((item) => {
            return {
              src: item.pcFileUrl,
              path: item.h5Url,
              text: item.topic,
            };
          });
        setImageList(result);
      } else {
        setImageList(defaultImagesOptions());
      }
    }
    requireData();
  }, [locale]);
  return imagesList.length ? (
    <div className={styles.carouselImageListWrapper}>
      <Carousel
        infinite={false}
        autoplay={true}
        arrows={clientReady}
        className={styles.carouselImageList}
        // prevArrow={
        //   <SlickButtonFix>
        //     <LeftOutlined />
        //   </SlickButtonFix>
        // }
        // nextArrow={
        //   <SlickButtonFix>
        //     <RightOutlined />
        //   </SlickButtonFix>
        // }
        dots={false}
        autoplaySpeed={6000}
      >
        {imagesList.map((item, index) => {
          return (
            <div
              key={index}
              className={styles.imageItem}
              onClick={() => onImageClick(item)}
            >
              {item.src && (
                <Image
                  className={styles.img}
                  loader={({ src, width }) => {
                    return src + "?w=" + width;
                  }}
                  width={270}
                  height={150}
                  src={item.src}
                  alt=""
                  priority={true}
                />
              )}
              <div className={styles.title}>{item.text}</div>
            </div>
          );
        })}
      </Carousel>
    </div>
  ) : (
    ""
  );
}
